import { IEventrFlight } from '@eventr/common'
import { useMemo } from 'react'
import { useGlobalRouter } from '../../feat/globalRouter/useGlobalRouter'
import { useScreenTypeContext } from '../state/screenTypeProvider'
import { FlightAirports } from './flightComponents/flightAirports'
import { FlightBookingInfo } from './flightComponents/flightBookingInfo'
import { FlightDate } from './flightComponents/flightDate'
import { FlightHeader } from './flightComponents/flightHeader'
import { FlightTimes } from './flightComponents/flightTimes'
import { useMatchTagsAndUsers } from './hooks/useMatchTagsAndUsers'
import { ObjectProvider } from './providers/objectProvider'
import { BaseCard } from './subComponents/baseCard'
interface FlightCardProps {
    id?: string
    data?: IEventrFlight
    past?: boolean
    border?: boolean
}

export const FlightCard = ({ id, data, past }: FlightCardProps) => {
    const { pushPath } = useGlobalRouter()
    const { screenType } = useScreenTypeContext()
    const { matchTagsAndUser } = useMatchTagsAndUsers()

    const passenger = useMemo(() => {
        if ((data?.passengers_list?.length ?? 0) === 0) {
            return null
        }
        return data?.passengers_list.find((passenger) => {
            if (passenger.users) {
                return passenger.users?.some((user) => {
                    return matchTagsAndUser(user)
                })
            } else {
                return []
            }
        })
    }, [data?.passengers_list, matchTagsAndUser])
    if (!data) return null

    const attachments = {
        notes: data.notes,
        extra_docs: data.extra_docs,
        website: data.website,
    }

    const FlightAirport = (
        <FlightAirports
            origin={data.departure?.dep_name}
            destination={data.arrival?.arr_name}
            originTerminal={data.departure?.dep_terminal}
            destinationTerminal={data.arrival?.arr_terminal}
        />
    )
    const FlightTimeSection = (
        <FlightTimes
            originAirportABR={data.outboundAirportAbr}
            destinationAirportABR={data.inboundAirportAbr}
            destinationTime={data.arrival?.arr_time}
            originTime={data.departure?.dep_time}
        />
    )
    const FlightBookingSection = (
        <FlightBookingInfo
            attachments={attachments}
            passenger={passenger ?? undefined}
            passengers={data.passengers_list}
            chatNames={[data.bookref]}
        />
    )

    const onClick = () => {
        pushPath(`/item/flight/${data._id}`)
    }

    return (
        <ObjectProvider past={past ?? false} _id={data._id} sectionID="2">
            {screenType === 'upNext' ? (
                <BaseCard id={id} onClick={onClick} past={past}>
                    <FlightHeader
                        label={data.label}
                        flightNumber={data.bookref}
                        labelTime={data.labelTime}
                        visibility={data.visibility}
                        departure={data.departure?.dep_time}
                    />
                    {FlightAirport}
                    {FlightTimeSection}
                    {FlightBookingSection}
                </BaseCard>
            ) : screenType === 'edit' ? (
                <BaseCard id={id} past={past}>
                    <FlightDate date={data.flightDate} />
                    {FlightAirport}
                    {FlightTimeSection}
                    {FlightBookingSection}
                </BaseCard>
            ) : screenType === 'personal' ? (
                <BaseCard id={id} onClick={onClick} past={past}>
                    <FlightDate date={data.flightDate} />
                    {FlightAirport}
                    {FlightTimeSection}
                    {FlightBookingSection}
                </BaseCard>
            ) : screenType === 'team' || screenType === 'teamMember' ? (
                <BaseCard id={id} past={past}>
                    <FlightHeader
                        label={data.label}
                        flightNumber={data.bookref}
                        labelTime={data.labelTime}
                        visibility={data.visibility}
                        departure={data.departure?.dep_time}
                    />
                    {FlightAirport}
                    {FlightTimeSection}
                    <FlightBookingInfo
                        attachments={attachments}
                        passengers={data.passengers_list}
                        chatNames={[data.bookref]}
                    />
                </BaseCard>
            ) : null}
        </ObjectProvider>
    )
}
